/**
 * axios请求封装文件
 * 使用方法: 引用需要的请求方法{Get/Post/Put/Delete}
 */
import axios from 'axios'
import { MessageBox, Notification } from 'element-ui'
import mainVue from '../main'
// 方法
import { handleRequestData } from '@/utils/request-operate'
import {
  showFullScreenLoading,
  tryHideFullScreenLoading
} from '@/utils/loading'
import { portalType } from '@/setting'

// 正式环境
const requestBaseURL = 'http://api.cang100.com:7799/'
// 沙盒测试环境
// const requestBaseURL = 'http://sandboxapi.cang100.cn:7799/'
// 本地开发环境
// const requestBaseURL = 'http://localhost:7799/'

// create an axios instance
const service = axios.create({
  baseURL: requestBaseURL, // 基础请求地址
  // baseURL: '/api', // 基础请求地址
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// 请求前的拦截器
service.interceptors.request.use(
  // eslint-disable-next-line arrow-body-style
  config => {
    // 请求发出前做的事
    if (!config.hideLoading) {
      showFullScreenLoading()
    }
    // config.url = config.baseURL + config.url
    const requestData = handleRequestData(
      config.data,
      config.url,
      config.baseURL
    )
    config['data'] = requestData
    let url = config.url
    if (url.indexOf('Common') === -1) {
      url = url.substring(url.lastIndexOf('/api'))
      config['url'] = config.baseURL + portalType + '/' + url
    }
    return config
  },
  error => {
    // do something with request error
    // eslint-disable-next-line no-console
    Notification({
      title: '网络错误',
      type: 'error',
      message: `请检查网络后重试，如需帮助请联系客服。错误: ${error}`
    })
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  // eslint-disable-next-line consistent-return
  response => {
    tryHideFullScreenLoading()
    const res = response.data
    // 对BE传入的状态码进行判断
    if (response.status !== 200) {
      switch (res.code) {
        default:
          Notification({
            title: '警报',
            type: 'warning',
            // eslint-disable-next-line prefer-template
            message: res.msg + ' 错误码:' + res.code
          })
      }
    } else {
      /**
       * Success = 1,
       * ParameterError = -3,
       * SecurityVerificationFailed = -1,
       * InternalServiceError = -2,
       * BusinessRuleFailed = 0,
       * SuspiciousRequest = -4,
       * RepeatRequest = -5,
       */
      switch (res.Code) {
        case 1:
          break
        case -1:
          // 登录失效
          Notification({
            title: '您的登录已失效，请重新登录',
            type: 'error'
          })
          // 返回登录界面(延迟500毫秒后，返回到登录界面)
          setTimeout(() => {
            mainVue.$router.replace('/login?1').catch(error => error)
          }, 500)
          break
        case 0:
          Notification({
            title: res.Message,
            type: 'warning',
            message: `错误码：${res.Code}`
          })
          break
        case -3:
        case -2:
        case -5:
          Notification({
            title: '错误，请截图联系客服',
            type: 'warning',
            message: `${res.Message} 错误码 ${res.Code}`
          })
          break
        case -4:
          Notification({
            title: '可疑的请求，请检查您电脑上的时间是否准确',
            type: 'warning',
            message: `错误码 ${res.Code}`
          })
          break
        default:
          Notification({
            title: res.Message,
            type: 'warning',
            message: `错误码 ${res.Code}`
          })
      }
      return res
    }
  },
  error => {
    // eslint-disable-next-line no-console
    tryHideFullScreenLoading()
    try {
      if (
        error.hasOwnProperty('response') &&
        error.response.hasOwnProperty('status')
      ) {
        switch (error.response.status) {
          // 错误信息处理，截取报错的错误码
          case 400:
            Notification({
              title: '错误的链接，请截图联系客服',
              message: error,
              type: 'error',
              duration: 2500
            })
            break
          case 401:
            // to re-login
            MessageBox.confirm(
              '您的登录状态已过期，您可以点击取消并停留在这个页面或者退出当前系统。',
              '确认退出',
              {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              this.$store.dispatch('user/resetToken').then(() => {
                location.reload()
              })
            })
            break
          case 405:
            Notification({
              title: '该请求不被允许，请截图联系客服',
              message: error,
              type: 'error',
              duration: 2500
            })
            break
          default:
            Notification({
              title: '请求错误，请截图联系客服',
              message: error,
              type: 'error',
              duration: 2500
            })
        }
      } else {
        const status = error.message.split(' ')
        // 超时判断
        if (status[0] === 'timeout') {
          Notification({
            title: '请求超时，请重新请求或刷新页面',
            type: 'error'
          })
        }
        // 是否已登录判断
        if (error.message === 'input is invalid type') {
          // 先判断localStorage中是否存在登录信息，有则为"输入错误"，反之则为"没有登录"
          if (window.localStorage.getItem('Session-Id-Key')) {
            Notification({
              title: '输入有误',
              type: 'error'
            })
          } else if (
            mainVue.$route.path !== '/shopImpower' &&
            mainVue.$route.path !== '/rechargeRedirect' &&
            mainVue.$route.path !== '/404'
          ) {
            // 在授权、支付、404页面不进行判断
            // 没有找到存储在localStorage的内容，判断为用户未登录
            // 自动登录下的提示
            if (JSON.parse(window.localStorage.getItem('autoLogin'))) {
              Notification({
                title: '自动登录失效',
                type: 'error',
                message: '请重新登录'
              })
            } else {
              Notification({
                title: '未登录',
                type: 'error',
                message: '请先登录'
              })
            }
            // 返回登录界面(延迟500毫秒后，返回到登录界面)
            setTimeout(() => {
              mainVue.$router.replace('/login?1').catch(error => error)
            }, 500)
          }
        }
      }
    } catch (err) {
      const errorTips = String(error).split('Error: ')[1]
      Notification({
        title: '网络错误',
        type: 'error',
        message: `请检查网络后重试，如需帮助请联系客服。错误: ${errorTips}`
      })
    }
    return Promise.reject(error)
  }
)

/**
 * 封装的post方法
 * @param {string} url 接口
 * @param {object} params 参数
 * @param {object} headers 头部参数
 */
export function fetchPost (url, params, headers, hideLoading) {
  return new Promise((resolve, reject) => {
    service
      .post(url, params, {
        headers,
        hideLoading
      })
      .then(
        response => {
          if (response.Code === -5) {
            // Repeat Request错误，重新请求一次
            fetchPost(url, params, headers).then(data => {
              resolve(data)
            })
          } else {
            resolve(response)
          }
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 封装的get请求方法
 * @param {string} url 接口名
 * @param {object} params 参数
 * @param {object} headers 头部参数
 */
export function fetchGet (url, params, headers) {
  return new Promise((resolve, reject) => {
    service
      .get(url, { params, headers })
      .then(
        response => {
          resolve(response)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 自助查询接口
 * @param {*} url 接口名
 * @param {*} params 参数
 * @param {*} headers 头部参数
 */
export function searchGet (urlParams, params, headers) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `http://cloud.api.cpsfba.com/order-server/router/find/list?numberList=${urlParams}`,
      data: params,
      headers
    })
      .then(
        response => {
          switch (response.status) {
            // 成功请求
            case 200:
              resolve(response)
              break
            default:
          }
        },
        err => {
          Notification({
            title: '警报',
            type: 'warning',
            // eslint-disable-next-line prefer-template
            message: err.msg + ' 错误码:' + err.code
          })
          reject(err)
        }
      )
      .catch(error => {
        Notification({
          title: '警报',
          type: 'warning',
          // eslint-disable-next-line prefer-template
          message: error.msg + ' 错误码:' + error.code
        })
        reject(error)
      })
  })
}

/**
 * OSS上传方法
 * @param {*} url 上传OSS地址(地址是通过请求得到的)
 * @param {*} params 参数
 * @param {*} headers 头部参数
 */
export function uploadOSS (url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `http://${url}`,
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(
      response => {
        switch (response.status) {
          // 成功请求
          case 200:
            resolve(response)
            break
          default:
        }
      },
      err => {
        console.log(err)
        let errorMessage = ''
        if (err.hasOwnProperty('msg') && err.hasOwnProperty('code')) {
          errorMessage = err.msg + ' 错误码:' + err.code
        } else {
          errorMessage = err
        }
        Notification({
          title: '警报',
          type: 'warning',
          // eslint-disable-next-line prefer-template
          message: errorMessage
        })
        reject(err)
      }
    )
  })
}

/**
 * 注册功能通用请求方法
 * @param {*} url 接口名
 * @param {*} params 参数
 * @param {*} headers 头部参数
 */
export function registerRequest (url, params) {
  showFullScreenLoading()
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: requestBaseURL + url,
      data: params
    })
      .then(
        response => {
          tryHideFullScreenLoading()
          resolve(response.data)
        },
        err => {
          tryHideFullScreenLoading()
          reject(err)
        }
      )
      .catch(error => {
        tryHideFullScreenLoading()
        reject(error)
      })
  })
}

/**
 * 请求微信支付支付结果
 * @param {String} outTradeNo 商户订单号
 * @param {String} MerchantId 商户号
 */
export function getWechatPayDefaultRequest (
  outTradeNo,
  merchantId,
  authorization
) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      // url: `/wechat/${outTradeNo}?mchid=${merchantId}`, // 本地测试时使用这个实现跨域
      url: `https://api.mch.weixin.qq.com/v3/pay/transactions/out-trade-no/${outTradeNo}?mchid=${merchantId}`, // 线上测试时使用这个直接访问即可
      crossdomain: true,
      data: { params: '' },
      headers: { Authorization: authorization }
    })
      .then(
        response => {
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 封装的put请求方法
 * @param {string} url 接口
 * @param {object} params 参数
 * @param {object} headers 头部参数
 */
export function fetchPut (url, params, headers) {
  return new Promise((resolve, reject) => {
    service
      .put(url, params, {
        headers
      })
      .then(
        response => {
          resolve(response)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * 封装的delete请求方法
 * @param {string} url 接口名
 * @param {object} params 参数
 * @param {object} headers 头部参数
 */
export function fetchDelete (url, params, headers) {
  return new Promise((resolve, reject) => {
    service
      .delete(
        url,
        { params },
        {
          headers
        }
      )
      .then(
        response => {
          resolve(response)
        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}

export default {
  fetchPost,
  fetchGet,
  fetchPut,
  fetchDelete,
  service,
  searchGet,

  registerRequest
}



// WEBPACK FOOTER //
// ./src/utils/request.js